import React, { useEffect, useReducer} from 'react';
import {Container, Row,Button, Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import Subfooter from './Subfooter';

const Realestate = () => {
    useEffect(() =>{
        document.title = "Real Estate | Rich-Oak Group"
    },[])

    return (
      
      <div>





<div className="homepageslider" id="homepageslider">
<Header/>
{/* <Container className=''> */}


<div  id="realestatebox">
    <Row >
    <div className="col-lg-7 col-md-12">
        <div className='hmfirstinnerbox'>
        <h3 className="hmfirstboxheading">Real Estate</h3>
        <p className='description hmfirstboxdescription'>We are building long-term relationships with our clients, partnering with<br/>
        individuals and institutions to achieve long term financial growth.</p>
        
        <p class="centermobile">
        <a href="#learnmore"><button className='hmfirstboxbutton hmbuttons'>LEARN MORE</button></a>
        {/* <h4 className="hmbuttons hmvot">View our team <img src="images/arrow_forward.png"/></h4> */}
        </p>

  
        </div>
    </div>
    </Row>
    </div>



    <div className='hmsecondbox' id="learnmore">
    
    </div>


    <div className='hmthirdbox'>
    <div className=''>
        {/* <Container> */}
            <Row>
                <div className='col-md-6 hideipad'>
                <img style={{width:"100%"}} src="images/estate.jpg"/> 
                {/* <iframe className="img-fluid" width="560" height="415" src="https://www.youtube.com/embed/sWVVazhSFuE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
                    </div>

                    {/* <div className='col-md-1'></div> */}

                    <div className='col-lg-6 col-md-12'>
                    <h1 className="hmwwd">Our <span style={{color:"#D80032"}}> Impact </span></h1>
                    {/* <hr class="hpwwdhr1"/> */}
                    <p  className="hmwwdp"></p>
               
                    <p className='hmsecondboxdescription'>Rich-Oak Group is a financial institution building reliable financial partnerships with individuals and institutions through professionalism, 
                        innovation and providing premium value. Our vision is to be Africa's most reliable financial partner. 
                        We invest capital on behalf of individuals and institutions across the alternative asset classes in real estate, 
                        credit and agriculture, increasing the wealth of our investors.
                         Our businesses are impact driven, providing support to various industries and sectors.</p>
                    </div>

                    {/* <div className='col-md-5 formobileonly'>
                <iframe className="img-fluid hmytvideo" width="560" height="415" src="https://www.youtube.com/embed/sWVVazhSFuE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div> */}

               
                
            </Row>
        {/* </Container> */}
        </div>

        
    </div>


 

 <div className='hmfourthbox'>
 <Row>
                      

                      <div class="col-lg-6 col-md-12 blogmobile">
                          <img class="blogimagemobile" style={{width:"100%"}} src="images/3.jpeg"/>
                          <p className='hmciahead' style={{marginTop:"30px",marginLeft:"10px"}}>Real Estate Investment Fund</p>
                          <p className='hmblogbody'>
                              
                          The real estate investment fund allows Interested Investors hold a portion of prime real estate assets without needing to come up with the entire purchase amount while enjoying good returns.
                               </p>
                               <p className="centermobile">
                               <a target="_blank" rel="noreferrer" href="https://earthvii.com/homes">
                               <button  style={{marginLeft:"10px"}} class="hmfirstboxbutton">LEARN MORE</button>
                                   </a>
                                   </p>

                               {/* <p  className='hmblogdate'><span style={{color:"#999999"}}>October 11,2021 </span> <span className="hmreadarticle">Read article </span></p> */}

                      </div>

                      <div class="col-lg-6 col-md-12 blogmobile">
                      <img class="blogimagemobile2" style={{width:"100%"}}  src="images/2.jpeg"/>
                      <p className='hmciahead' style={{marginTop:"30px",marginLeft:"10px"}}>Earth <span style={{color:"#D80032"}}>VII</span></p>
                      <p className='hmblogbody'>
                      We provide affordable premium and luxury residential real estate with payment plans to reduce the burden of making a full deposit. We are not just building structures, we are building lasting homes to hold memories for generations.
                               </p>

                               <p className="centermobile">
                               <a target="_blank"  rel="noreferrer"  href="https://earthvii.com/homes">
                               <button  style={{marginLeft:"10px"}} class="hmfirstboxbutton">LEARN MORE</button>
                                   </a>
                                   </p>
                               {/* <p  className='hmblogdate'><span style={{color:"#999999"}}>October 11,2021 </span> <span className="hmreadarticle">Read article </span></p> */}

                      </div>

                 
                  </Row>
 <div className='col-md-12'>
            <p className="whatwedohead margintop50mobile">Our <span style={{color:"#D80032"}}>Strategies</span> </p>
           <hr class="whatwedohr"/>
           <br/>
           <br/>
            </div>
    <div className=''>

            <Row>
         

                    <div className='col-md-5 divinvestments4 blogmobile'>
                    <div className=' blogmobile'>
                        <p className="hmciahead" style={{marginTop:"30px"}}><span style={{color:"#D80032"}}>1.</span> Identify</p>
                        <p  className='hmfourthboxinner'>
                        We identify real estate opportunities in prime locations across Abuja Nigeria. We look out for developed and secure locations with access to the city center and basic daily essentials.                          
                            </p>
                            </div>
                    </div>

                    <div className='col-md-1'></div>

                    <div className='col-md-5 divinvestments4'>
                    <div className=' blogmobile'>
                        <p className="hmciahead" style={{marginTop:"30px"}}><span style={{color:"#D80032"}}>2.</span> Due Diligence</p>
                        <p  className='hmfourthboxinner'>Our team of professionals provide expertise input through a rigorous evaluation process carrying out all necessary due diligence to vet all identified properties in-other to ensure a smooth and secure transaction.</p>
                        </div>
                   </div>

                   <div className='col-md-5 divinvestments4' style={{marginTop:"30px"}}>
                   <div className=' blogmobile'>
                  <p className="hmciahead" style={{marginTop:"30px"}}><span style={{color:"#D80032"}}>3.</span> Evaluate</p>
                  <p  className='hmfourthboxinner'>
                  We evaluate each real estate asset to ensure it conforms with our investment criteria, with a goal to achieve the investment goals of our investors and provide above standard smart homes.                      </p>
                  </div>
              </div>
              <div className='col-md-1'></div>

              <div className='col-md-5 divinvestments4' style={{marginTop:"30px"}}>
              <div className=' blogmobile'>
                                      <p className="hmciahead" style={{marginTop:"30px"}}><span style={{color:"#D80032"}}>4.</span> Engage</p>
                  <p  className='hmfourthboxinner'>
                  We use only the best quality of materials in constructing all our projects. Houses under construction are open for interested individuals to make installmental payments before each project is fully completed.                      </p>
                  </div>
             </div>

               
               
                
            </Row>

        
   
        </div>
    </div> 



<Subfooter/>


    </div>







    <Footer/>
    </div>


    )
    
    
}


export {Realestate as default}